export const Dialog = {
  SHOW: 'SHOW',
  HIDE: 'HIDE',
}

export const Step = {
  GO_TO_STEP: 'GO_TO_STEP',
  GO_BACK: 'GO_BACK',
}

export const Email = {
  START_EMAIL_CHECK: 'START_EMAIL_CHECK',
  CANCEL_EMAIL_CHECK: 'CANCEL_EMAIL_CHECK',
  RECEIVE_EMAIL_CHECK: 'RECEIVE_EMAIL_CHECK',
}

export const Phone = {
  CHECK_NUMBER: 'CHECK_NUMBER',
  CANCEL_CHECK_NUMBER: 'CANCEL_CHECK_NUMBER',
  RECEIVE_CHECK_NUMBER: 'RECEIVE_CHECK_NUMBER',
  OPEN_SMS_CODE_DIALOG: 'OPEN_SMS_CODE_DIALOG',
  CLOSE_SMS_CODE_DIALOG: 'CLOSE_SMS_CODE_DIALOG',
  CHECK_CODE: 'CHECK_CODE',
  CANCEL_CHECK_CODE: 'CANCEL_CHECK_CODE',
  RECEIVE_CODE_CHECK: 'RECEIVE_CODE_CHECK',
}

export const Address = {
  CHECK_ADDRESS: 'CHECK_ADDRESS',
  CANCEL_ADDRESS_CHECK: 'CANCEL_ADDRESS_CHECK',
  RECEIVE_ADDRESS_CHECK: 'FINISH',
}



// WEBPACK FOOTER //
// ./src/sections/firstlogin/types.js